namespace TabAurous.OMS {
    export interface PosCustomerMasterRow {
        POSCustomerId?: number;
        PosCustomerCode?: string;
        Prefix?: string;
        FirstName?: string;
        LastName?: string;
        Gender?: string;
        MaritialStatus?: string;
        Mobile?: string;
        Mobile2?: string;
        Email?: string;
        TelR?: string;
        TelO?: string;
        BirthDate?: string;
        Anniversary?: string;
        NationalityId?: number;
        ReligonId?: number;
        CountryId?: number;
        StateId?: number;
        CityId?: number;
        CityName?: string;
        CountryName?: string;
        StateName?: string;
        Address?: string;
        Pin?: string;
        GroupId?: number;
        ParentId?: number;
        RefId?: number;
        AllowCredit?: boolean;
        CreditLimit?: number;
        IsDisabled?: boolean;
        HomeBranchId?: number;
        PanNumber?: string;
        TaxId?: string;
        ImagePath?: string;
    }

    export namespace PosCustomerMasterRow {
        export const idProperty = 'POSCustomerId';
        export const nameProperty = 'PosCustomerCode';
        export const localTextPrefix = 'OMS.PosCustomerMaster';
        export const deletePermission = 'Masters:POSCustomer:Delete';
        export const insertPermission = 'Masters:POSCustomer:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:POSCustomer:Edit';

        export declare const enum Fields {
            POSCustomerId = "POSCustomerId",
            PosCustomerCode = "PosCustomerCode",
            Prefix = "Prefix",
            FirstName = "FirstName",
            LastName = "LastName",
            Gender = "Gender",
            MaritialStatus = "MaritialStatus",
            Mobile = "Mobile",
            Mobile2 = "Mobile2",
            Email = "Email",
            TelR = "TelR",
            TelO = "TelO",
            BirthDate = "BirthDate",
            Anniversary = "Anniversary",
            NationalityId = "NationalityId",
            ReligonId = "ReligonId",
            CountryId = "CountryId",
            StateId = "StateId",
            CityId = "CityId",
            CityName = "CityName",
            CountryName = "CountryName",
            StateName = "StateName",
            Address = "Address",
            Pin = "Pin",
            GroupId = "GroupId",
            ParentId = "ParentId",
            RefId = "RefId",
            AllowCredit = "AllowCredit",
            CreditLimit = "CreditLimit",
            IsDisabled = "IsDisabled",
            HomeBranchId = "HomeBranchId",
            PanNumber = "PanNumber",
            TaxId = "TaxId",
            ImagePath = "ImagePath"
        }
    }
}
